// â”€â”€â”€ Create contact modal (Phase 3) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//
// Wraps ContactEditForm in a modal. Used by ContactsPage's "+ New Contact"
// button. On success, calls onCreated(contactId) so parent can refetch list.

import React from 'react';
import ContactEditForm from './ContactEditForm';
import { createContact } from '../services/contactsService';
import type { ContactCreateInput } from '../services/contactsService';

interface Props {
  open: boolean;
  onClose: () => void;
  onCreated: (contactId: string, wasCreated: boolean) => void;
}

const CreateContactModal: React.FC<Props> = ({ open, onClose, onCreated }) => {
  if (!open) return null;

  async function handleSubmit(data: ContactCreateInput | Partial<any>) {
    const result = await createContact(data as ContactCreateInput);
    onCreated(result.contactId, result.wasCreated);
    onClose();
  }

  return (
    <>
      <div
        className="fixed inset-0 bg-black/40 z-50"
        onClick={onClose}
      />
      <div className="fixed inset-0 z-50 flex items-start justify-center p-4 overflow-y-auto pointer-events-none">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl pointer-events-auto my-8"
             style={{ fontFamily: 'Inter, sans-serif' }}>
          {/* Header */}
          <div className="px-6 py-4 border-b border-stone-100 flex items-center justify-between">
            <h2 className="text-lg font-bold text-stone-900">New Contact</h2>
            <button
              onClick={onClose}
              className="text-stone-400 hover:text-stone-700"
              aria-label="Close"
            >
              <span className="material-symbols-rounded" style={{ fontSize: 20 }}>close</span>
            </button>
          </div>

          {/* Form */}
          <div className="px-6 py-5">
            <ContactEditForm
              mode="create"
              onSubmit={handleSubmit}
              onCancel={onClose}
              submitLabel="Create Contact"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateContactModal;
